export default "__VITE_ASSET__dVqRxuTS__"